<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-book" main="Paradas" sub="Cadastrar, alterar ou deletar Paradas" />
        <b-form>
            <input id="parada-id" type="hidden" v-model="parada.id" />
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Titulo:" label-for="parada-titulo">
                        <b-form-input id="parada-titulo" type="text"
                            v-model="parada.titulo"
                            placeholder="Informe o titulo do parada."
                            :class="{ 'inputError': $v.parada.titulo.$error }"
                            class="textInput"
                            @keydown.tab="$v.parada.titulo.$touch"/>
                        <span class="error" v-if="!$v.parada.titulo.required && $v.parada.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.parada.titulo.minLength && $v.parada.titulo.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" @click="save" class="mt-3 botaoInput">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mt-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-paradas" 
                class="text-center table table-sm" 
                :items="paradas.length>0?paradas:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadParada(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-paradas"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-paradas" 
                class="text-center table table-sm" 
                :items="paradas.length>0?paradas:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadParada(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-paradas"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'paradas',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            parada: {},
            paradas: [],
            fields: [
                { key: 'titulo', label: 'Título', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        parada: {
            titulo: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: {
        rows() {
            return this.paradas.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadParadas() {
            const url = `${baseApiUrl}/backend/paradas.php`
            axios.get(url).then(res => {
                this.paradas = res.data
                if(this.paradas.length > 0){
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.parada = {}
            this.loadParadas()
            this.$v.parada.$reset()
        },
        save() {
            this.$v.parada.$touch()
            if(!this.$v.parada.$error){
                const method = this.parada.id ? 'put' : 'post'
                const id = this.parada.id ? `?id=${this.parada.id}` : ''
                axios[method](`${baseApiUrl}/backend/paradas.php${id}`, this.parada)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Parada inserida com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Parada alterada com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(parada) {
            const sure = confirm("Deseja realmente excluir a parada?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/paradas.php`
                axios.delete(url, { data: parada })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Parada excluída com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadParada(parada) {
            this.parada = { ...parada }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadParadas()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.paradas.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>
